import { render, staticRenderFns } from "./UltimosBoletines.vue?vue&type=template&id=50bb2319&scoped=true"
import script from "./UltimosBoletines.vue?vue&type=script&lang=js"
export * from "./UltimosBoletines.vue?vue&type=script&lang=js"
import style0 from "./UltimosBoletines.vue?vue&type=style&index=0&id=50bb2319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb2319",
  null
  
)

export default component.exports